import { FormControl, ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';

/**
 *
 *
 * @export validator for input credit card number
 * @param {FormControl} control
 * @returns {boolean}
 */

export function validateCardNumber(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: boolean } | null => {
		const number = control.value;
		const regexPattern = new RegExp('^[0-9]{15,16}$');

		let isValid = false;

		if (regexPattern.test(number)) {
			if (luhnCheck(number)) {
				isValid = true;
			}
		}

		if (!isValid) {
			return { 'creditCardInvalid': true };
		} else {
			return null;
		}

	}
}

export function validateCVCNumber(activeCardType:string): ValidatorFn {
	return (control: AbstractControl): { [key: string]: boolean } | null => {
		let isValid = false;
		const cvc = control.value;
		const maxLength3Valid = new RegExp('^.{1,3}$');
		const maxLength4Valid = new RegExp('^.{1,4}$');


		if (activeCardType != null && activeCardType != 'amex') {
			isValid = (maxLength3Valid.test(cvc));
		} else {
			isValid = (maxLength4Valid.test(cvc));
		}

		if (!isValid) {
			return { 'maxLength': true };
		} else {
			return null;
		}
	}
}

export function INDRA_creditCardValidator(arrayCard: string[], selectedCard?: string): ValidatorFn {

	return (control: AbstractControl): { [key: string]: boolean } | null => {
		const number = control.value;
		const patternVI = new RegExp('^4[0-9]{0,}$');
		const patternMC = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
		const patternAX = new RegExp('^3[47][0-9]{0,}$');
		const patternMA = new RegExp('^(5[06789]|6)[0-9]{0,}$');
		const patternEL = new RegExp('^(?:401178|401179|431274|438935|451416|457393|457631|457632|504175|627780|636297|636368|655000|655001|651652|651653|651654|650485|650486|650487|650488|506699|5067[0-6][0-9]|50677[0-8]|509\\d{3})\\d{10}$');
		const patternHC = new RegExp('^(606282\\d{10}(\\d{3})?)|(3841\\d{15})$');
		const patternDN = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
		const patternTP = new RegExp('^1[0-9]{0,}$');
		const patternDS = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');
		const patternAcceptAll = new RegExp('^[0-9]*$');

		let valid = false;

		if (selectedCard) {
			switch (selectedCard) {
				case 'VI':
					valid = (patternVI.test(number));
					break;
				case 'MC':
					valid = (patternMC.test(number));
					break;
				case 'AX':
					valid = (patternAX.test(number));
					break;
				case 'MA':
					valid = (patternMA.test(number));
					break;
				case 'EL':
					valid = (patternEL.test(number));
					break;
				case 'HC':
					valid = (patternHC.test(number));
					break;
				case 'DC':
					valid = (patternDN.test(number));
					break;
				case 'DS':
					valid = (patternDS.test(number));
					break;
				case 'TP':
					valid = (patternTP.test(number));
					break;
				case 'BC':
					valid = true; // TODO add REGEX for Bancontac card number
					break;
				default: break;
			}

		} else {
			if (patternVI.test(number) && arrayCard.findIndex((x) => x == 'VI') > -1) {
				valid = true;
			} else if (patternMC.test(number) && arrayCard.findIndex((x) => x == 'MC') > -1) {
				valid = true;
			} else if (patternAX.test(number) && arrayCard.findIndex((x) => x == 'AX') > -1) {
				valid = true;
			} else if (patternMA.test(number) && arrayCard.findIndex((x) => x == 'MA') > -1) {
				valid = true;
			} else if (patternEL.test(number) && arrayCard.findIndex((x) => x == 'EL') > -1) {
				valid = true;
			} else if (patternHC.test(number) && arrayCard.findIndex((x) => x == 'HC') > -1) {
				valid = true;
			} else if (patternDN.test(number) && arrayCard.findIndex((x) => x == 'DC') > -1) {
				valid = true;
			} else if (patternDS.test(number) && arrayCard.findIndex((x) => x == 'DS') > -1) {
				valid = true;
			} else if (patternTP.test(number) && arrayCard.findIndex((x) => x == 'TP') > -1) {
				valid = true;
			} else if (arrayCard.findIndex((x) => x == 'BC') > -1) {
				// TODO add REGEX for Bancontac card number
				valid = true;
			}

		}

		if (!valid) {
			return { 'creditCardInvalid': true };
		}
		return null;

	};
}

export function INDRA_cvcCustomValidator(controlCreditCardName: string, cvcControlName: string) {

	return (formGroup: FormGroup) => {
		const creditCardControl = formGroup.controls[controlCreditCardName];
		const cvcControl = formGroup.controls[cvcControlName];

		if (cvcControl.errors && !cvcControl.errors.badValueFound) {
			return;
		}


		const patternTP = new RegExp('^1[0-9]{0,}$');
		const number = creditCardControl.value;
		const numberCvc = cvcControl.value;

		if (!patternTP.test(number)) {

			if (numberCvc !== undefined && numberCvc !== null && numberCvc !== '') {
				cvcControl.setErrors(null);
			} else {
				cvcControl.setErrors({ 'badValueFound': true });
			}
		} else {
			if (numberCvc === undefined || numberCvc === null || numberCvc === '') {
				cvcControl.setErrors({ 'badValueFound': true });
			} else {
				cvcControl.setErrors(null);
			}
		}
	};
}

function luhnCheck(num: string): boolean {
	let nCheck = 0, bEven = false;
	num = num.replace(/\D/g, "");

	for (var n = num.length - 1; n >= 0; n--) {
		var cDigit = num.charAt(n),
			nDigit = parseInt(cDigit, 10);

		if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

		nCheck += nDigit;
		bEven = !bEven;
	}

	return (nCheck % 10) == 0;
}
